import { requestCreator, UnknownError } from "../../common/actions/VisitApi";

export type ProviderNames = "facebook" | "twitter" | "linkedin";

export interface Provider {
  name: ProviderNames;
  available: boolean;
  canPost: boolean;
}

export const requestToLoadProviders = requestCreator<null, Provider[], UnknownError>(() => ({
  path: "/api/v2/project_supports/providers",
}));

export interface CreateSupportParams {
  projectId: number | string;
  message?: string;
  postToFacebook: boolean;
  postToTwitter: boolean;
  postToLinkedin: boolean;
  postAfterUpdatingFbPermission: boolean;
}

export const requestToCreateSupport = requestCreator<CreateSupportParams, null, UnknownError>(params => ({
  path: `/api/v2/project_supports`,
  method: "POST",
  body: {
    project_support: {
      message: params.message,
      project_id: params.projectId,
      post_to_fb_wall: params.postToFacebook,
      post_to_twitter: params.postToTwitter,
      post_to_linkedin: params.postToLinkedin,
      post_after_updating_fb_permission: params.postAfterUpdatingFbPermission,
    },
  },
}));



// WEBPACK FOOTER //
// ./frontend/src/project_supports/api/index.ts